<style lang="scss" scoped>
@import url(https://fonts.googleapis.com/css?family=Barlow);
  .text-box {
    display: inline-block;
    font-size: 14px;
    font-family: Helvetica;
    color: #111;
    line-height: 1.2;
    vertical-align: top;
    white-space: nowrap;
    word-wrap: normal;
    text-align: center;
  }
  .bg {
    // background-color: #FCC7C7
  }
  svg.prisma-svg {
    width: 100%;
    max-width: 68 0px;
  }
</style>

<template>
  <div>
    <div>
      <div class="col-12" v-if="ui.debug">
        VP:{{ui.viewport}}
        <br>
        <span v-if="0">{{prismaInfo}}</span>

        <div>
          <div class="col-12">
            <button class="btn btn-primary" @click="zoom(20)">zoom -</button>
            <button class="btn btn-primary" @click="zoom(-20)">zoom +</button>
            <button class="btn btn-primary" @click="area(20)">+</button>
            <button class="btn btn-primary" @click="area(-20)">-</button>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-4 ml-4 mb-4">
    


<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="662px" viewBox="-0.5 -0.5 662 761" content="&lt;mxfile host=&quot;app.diagrams.net&quot; modified=&quot;2021-01-19T15:52:04.944Z&quot; agent=&quot;5.0 (X11)&quot; etag=&quot;O0_bO3pEufrofeFwPpgg&quot; version=&quot;14.2.4&quot; type=&quot;google&quot;&gt;&lt;diagram id=&quot;ERasIOLuNtYQwxEtWGBE&quot; name=&quot;Page-1&quot;&gt;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&lt;/diagram&gt;&lt;/mxfile&gt;" onclick="(function(svg){var src=window.event.target||window.event.srcElement;while (src!=null&amp;&amp;src.nodeName.toLowerCase()!='a'){src=src.parentNode;}if(src==null){if(svg.wnd!=null&amp;&amp;!svg.wnd.closed){svg.wnd.focus();}else{var r=function(evt){if(evt.data=='ready'&amp;&amp;evt.source==svg.wnd){svg.wnd.postMessage(decodeURIComponent(svg.getAttribute('content')),'*');window.removeEventListener('message',r);}};window.addEventListener('message',r);svg.wnd=window.open('https://viewer.diagrams.net/?client=1&amp;page=0&amp;edit=_blank');}}})(this);" style="cursor:pointer;max-width:100%;max-height:761px;">
   <g>
      <path d="M 150 100 L 150 173.63" fill="none" stroke="#000000" stroke-miterlimit="10" pointer-events="stroke"/>
      <path d="M 150 178.88 L 146.5 171.88 L 150 173.63 L 153.5 171.88 Z" fill="#000000" stroke="#000000" stroke-miterlimit="10" pointer-events="all"/>
      <rect x="0" y="0" width="300" height="100" rx="15" ry="15" fill="#d9d9d9" stroke="none" pointer-events="all"/>
      <rect x="20" y="60" width="260" height="20" fill="none" stroke="none" pointer-events="all"/>
      <g transform="translate(-0.5 -0.5)">
         <switch>
            <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%" requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
               <div xmlns="http://www.w3.org/1999/xhtml" style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 258px; height: 1px; padding-top: 70px; margin-left: 21px;">
                  <div style="box-sizing: border-box; font-size: 0; text-align: center; ">
                     <div style="display: inline-block; font-size: 13px; font-family: Barlow; color: #000000; line-height: 1.2; pointer-events: all; white-space: normal; word-wrap: normal; "><font style="font-size: 13px">Records identified in the L·OVE platfrom</font></div>
                  </div>
               </div>
            </foreignObject>
            <text x="150" y="74" fill="#000000" font-family="Barlow" font-size="13px" text-anchor="middle">Records identified in the L·OVE platfrom</text>
         </switch>
      </g>
      <rect x="130" y="30" width="40" height="20" fill="none" stroke="none" pointer-events="all"/>
      <g transform="translate(-0.5 -0.5)">
         <switch>
            <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%" requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
               <div xmlns="http://www.w3.org/1999/xhtml" style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 38px; height: 1px; padding-top: 40px; margin-left: 131px;">
                  <div style="box-sizing: border-box; font-size: 0; text-align: center; ">
                     <div style="display: inline-block; font-size: 12px; font-family: Helvetica; color: #000000; line-height: 1.2; pointer-events: all; white-space: normal; word-wrap: normal; ">{{prismaInfo['Records identified in L·OVE platform (after duplicates automatically removed)']}}</div>
                  </div>
               </div>
            </foreignObject>
            <text x="150" y="44" fill="#000000" font-family="Helvetica" font-size="12px" text-anchor="middle">{{prismaInfo['Records identified in L·OVE platform (after duplicates automatically removed)']}}</text>
         </switch>
      </g>
      <path d="M 150 280 L 150 423.63" fill="none" stroke="#000000" stroke-miterlimit="10" pointer-events="stroke"/>
      <path d="M 150 428.88 L 146.5 421.88 L 150 423.63 L 153.5 421.88 Z" fill="#000000" stroke="#000000" stroke-miterlimit="10" pointer-events="all"/>
      <rect x="0" y="180" width="300" height="100" rx="15" ry="15" fill="#2b8182" stroke="none" pointer-events="all"/>
      <rect x="0" y="430" width="300" height="100" rx="15" ry="15" fill="#2b8182" stroke="none" pointer-events="all"/>
      <rect x="130" y="210" width="40" height="20" fill="none" stroke="none" pointer-events="all"/>
      <g transform="translate(-0.5 -0.5)">
         <switch>
            <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%" requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
               <div xmlns="http://www.w3.org/1999/xhtml" style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 38px; height: 1px; padding-top: 220px; margin-left: 131px;">
                  <div style="box-sizing: border-box; font-size: 0; text-align: center; ">
                     <div style="display: inline-block; font-size: 12px; font-family: Helvetica; color: #FFFFFF; line-height: 1.2; pointer-events: all; white-space: normal; word-wrap: normal; ">{{prismaInfo['Records Screened']}}</div>
                  </div>
               </div>
            </foreignObject>
            <text x="150" y="224" fill="#FFFFFF" font-family="Helvetica" font-size="12px" text-anchor="middle">{{prismaInfo['Records Screened']}}</text>
         </switch>
      </g>
      <rect x="20" y="230" width="260" height="20" fill="none" stroke="none" pointer-events="all"/>
      <g transform="translate(-0.5 -0.5)">
         <switch>
            <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%" requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
               <div xmlns="http://www.w3.org/1999/xhtml" style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 258px; height: 1px; padding-top: 240px; margin-left: 21px;">
                  <div style="box-sizing: border-box; font-size: 0; text-align: center; ">
                     <div style="display: inline-block; font-size: 13px; font-family: Barlow; color: #FFFFFF; line-height: 1.2; pointer-events: all; white-space: normal; word-wrap: normal; "><font style="font-size: 13px">Records screened<br /></font></div>
                  </div>
               </div>
            </foreignObject>
            <text x="150" y="244" fill="#FFFFFF" font-family="Barlow" font-size="13px" text-anchor="middle">Records screened&#xa;</text>
         </switch>
      </g>
      <path d="M 150 540 L 150 653.63" fill="none" stroke="#000000" stroke-miterlimit="10" pointer-events="stroke"/>
      <path d="M 150 658.88 L 146.5 651.88 L 150 653.63 L 153.5 651.88 Z" fill="#000000" stroke="#000000" stroke-miterlimit="10" pointer-events="all"/>
      <rect x="0" y="440" width="300" height="100" rx="15" ry="15" fill="#2b8182" stroke="none" pointer-events="all"/>
      <rect x="125" y="460" width="40" height="20" fill="none" stroke="none" pointer-events="all"/>
      <g transform="translate(-0.5 -0.5)">
         <switch>
            <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%" requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
               <div xmlns="http://www.w3.org/1999/xhtml" style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 38px; height: 1px; padding-top: 470px; margin-left: 126px;">
                  <div style="box-sizing: border-box; font-size: 0; text-align: center; ">
                     <div style="display: inline-block; font-size: 12px; font-family: Helvetica; color: #FFFFFF; line-height: 1.2; pointer-events: all; white-space: normal; word-wrap: normal; ">{{prismaInfo['Full text articles assessed for eligibility']}}</div>
                  </div>
               </div>
            </foreignObject>
            <text x="145" y="474" fill="#FFFFFF" font-family="Helvetica" font-size="12px" text-anchor="middle">{{prismaInfo['Full text articles assessed for eligibility']}}</text>
         </switch>
      </g>
      <rect x="20" y="490" width="260" height="20" fill="none" stroke="none" pointer-events="all"/>
      <g transform="translate(-0.5 -0.5)">
         <switch>
            <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%" requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
               <div xmlns="http://www.w3.org/1999/xhtml" style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 258px; height: 1px; padding-top: 500px; margin-left: 21px;">
                  <div style="box-sizing: border-box; font-size: 0; text-align: center; ">
                     <div style="display: inline-block; font-size: 13px; font-family: Barlow; color: #FFFFFF; line-height: 1.2; pointer-events: all; white-space: normal; word-wrap: normal; ">Full-text articles assessed for eligibility</div>
                  </div>
               </div>
            </foreignObject>
            <text x="150" y="504" fill="#FFFFFF" font-family="Barlow" font-size="13px" text-anchor="middle">Full-text articles assessed for eligibil...</text>
         </switch>
      </g>
      <rect x="0" y="660" width="300" height="100" rx="15" ry="15" fill="#2b8182" stroke="none" pointer-events="all"/>
      <rect x="125" y="680" width="40" height="20" fill="none" stroke="none" pointer-events="all"/>
      <g transform="translate(-0.5 -0.5)">
         <switch>
            <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%" requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
               <div xmlns="http://www.w3.org/1999/xhtml" style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 38px; height: 1px; padding-top: 690px; margin-left: 126px;">
                  <div style="box-sizing: border-box; font-size: 0; text-align: center; ">
                     <div style="display: inline-block; font-size: 12px; font-family: Helvetica; color: #FFFFFF; line-height: 1.2; pointer-events: all; white-space: normal; word-wrap: normal; ">{{prismaInfo['Total RCTs included']}}</div>
                  </div>
               </div>
            </foreignObject>
            <text x="145" y="694" fill="#FFFFFF" font-family="Helvetica" font-size="12px" text-anchor="middle">{{prismaInfo['Total RCTs included']}}</text>
         </switch>
      </g>
      <rect x="18" y="710" width="260" height="20" fill="none" stroke="none" pointer-events="all"/>
      <g transform="translate(-0.5 -0.5)">
         <switch>
            <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%" requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
               <div xmlns="http://www.w3.org/1999/xhtml" style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 258px; height: 1px; padding-top: 720px; margin-left: 19px;">
                  <div style="box-sizing: border-box; font-size: 0; text-align: center; ">
                     <div style="display: inline-block; font-size: 13px; font-family: Barlow; color: #FFFFFF; line-height: 1.2; pointer-events: all; white-space: normal; word-wrap: normal; ">
                        <div>RCTs Included</div>
                        <div v-if="prismaInfo['Total references RCTs included']" >({{prismaInfo['Total references RCTs included']}} references)<br /></div>
                     </div>
                  </div>
               </div>
            </foreignObject>
            <text x="148" y="724" fill="#FFFFFF" font-family="Barlow" font-size="13px" text-anchor="middle">RCTs Included...</text>
         </switch>
      </g>
      <rect v-if="prismaInfo['Records excluded based on type of Population/Intervention']" x="360" y="180" width="300" height="100" rx="15" ry="15" fill="#ffffff" stroke="#2b8182" stroke-width="3" pointer-events="all"/>
      <rect v-if="prismaInfo['Records excluded based on type of Population/Intervention']" x="490" y="200" width="40" height="20" fill="none" stroke="none" pointer-events="all"/>
      <g v-if="prismaInfo['Records excluded based on type of Population/Intervention']" transform="translate(-0.5 -0.5)">
         <switch>
            <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%" requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
               <div xmlns="http://www.w3.org/1999/xhtml" style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 38px; height: 1px; padding-top: 210px; margin-left: 491px;">
                  <div style="box-sizing: border-box; font-size: 0; text-align: center; ">
                     <div style="display: inline-block; font-size: 12px; font-family: Helvetica; color: #2B8182; line-height: 1.2; pointer-events: all; white-space: normal; word-wrap: normal; ">{{prismaInfo['Records excluded based on type of Population/Intervention']}}</div>
                  </div>
               </div>
            </foreignObject>
            <text x="510" y="214" fill="#2B8182" font-family="Helvetica" font-size="12px" text-anchor="middle">{{prismaInfo['Records excluded based on type of Population/Intervention']}}</text>
         </switch>
      </g>
      <rect v-if="prismaInfo['Records excluded based on type of Population/Intervention']" x="380" y="230" width="260" height="20" fill="none" stroke="none" pointer-events="all"/>
      <g v-if="prismaInfo['Records excluded based on type of Population/Intervention']" transform="translate(-0.5 -0.5)">
         <switch>
            <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%" requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
               <div xmlns="http://www.w3.org/1999/xhtml" style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 258px; height: 1px; padding-top: 240px; margin-left: 381px;">
                  <div style="box-sizing: border-box; font-size: 0; text-align: center; ">
                     <div style="display: inline-block; font-size: 13px; font-family: Barlow; color: #2B8182; line-height: 1.2; pointer-events: all; white-space: normal; word-wrap: normal; ">Records excluded based on type of Population/Intervention</div>
                  </div>
               </div>
            </foreignObject>
            <text x="510" y="244" fill="#2B8182" font-family="Barlow" font-size="13px" text-anchor="middle">Records excluded based on type of Popula...</text>
         </switch>
      </g>
      <rect x="490" y="505" width="40" height="20" fill="none" stroke="none" pointer-events="all"/>
      <g transform="translate(-0.5 -0.5)">
         <switch>
            <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%" requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
               <div xmlns="http://www.w3.org/1999/xhtml" style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 38px; height: 1px; padding-top: 515px; margin-left: 491px;">
                  <div style="box-sizing: border-box; font-size: 0; text-align: center; ">
                     <div style="display: inline-block; font-size: 12px; font-family: Helvetica; color: #FFFFFF; line-height: 1.2; pointer-events: all; white-space: normal; word-wrap: normal; ">{{prismaInfo['Ongoing studies']}}</div>
                  </div>
               </div>
            </foreignObject>
            <text x="510" y="519" fill="#FFFFFF" font-family="Helvetica" font-size="12px" text-anchor="middle">{{prismaInfo['Ongoing studies']}}</text>
         </switch>
      </g>
      <rect x="385" y="535" width="260" height="20" fill="none" stroke="none" pointer-events="all"/>
      <g transform="translate(-0.5 -0.5)">
         <switch>
            <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%" requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
               <div xmlns="http://www.w3.org/1999/xhtml" style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 258px; height: 1px; padding-top: 545px; margin-left: 386px;">
                  <div style="box-sizing: border-box; font-size: 0; text-align: center; ">
                     <div style="display: inline-block; font-size: 13px; font-family: Barlow; color: #FFFFFF; line-height: 1.2; pointer-events: all; white-space: normal; word-wrap: normal; ">Ongoing Studies</div>
                  </div>
               </div>
            </foreignObject>
            <text x="515" y="549" fill="#FFFFFF" font-family="Barlow" font-size="13px" text-anchor="middle">Ongoing Studies</text>
         </switch>
      </g>
      <rect v-if="prismaInfo['Articles excluded']" x="355" y="425" width="300" height="130" rx="19.5" ry="19.5" fill="#ffffff" stroke="#2b8182" stroke-width="3" pointer-events="all"/>
      <rect v-if="prismaInfo['Articles excluded']" x="485" y="445" width="40" height="20" fill="none" stroke="none" pointer-events="all"/>
      <g v-if="prismaInfo['Articles excluded']" transform="translate(-0.5 -0.5)">
         <switch>
            <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%" requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
               <div xmlns="http://www.w3.org/1999/xhtml" style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 38px; height: 1px; padding-top: 455px; margin-left: 486px;">
                  <div style="box-sizing: border-box; font-size: 0; text-align: center; ">
                     <div style="display: inline-block; font-size: 12px; font-family: Helvetica; color: #2B8182; line-height: 1.2; pointer-events: all; white-space: normal; word-wrap: normal; ">{{prismaInfo['Articles excluded']}}</div>
                  </div>
               </div>
            </foreignObject>
            <text x="505" y="459" fill="#2B8182" font-family="Helvetica" font-size="12px" text-anchor="middle">{{prismaInfo['Articles excluded']}}</text>
         </switch>
      </g>
      <rect v-if="prismaInfo['Articles excluded']" x="375" y="465" width="260" height="20" fill="none" stroke="none" pointer-events="all"/>
      <g v-if="prismaInfo['Articles excluded']" transform="translate(-0.5 -0.5)">
         <switch>
            <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%" requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
               <div xmlns="http://www.w3.org/1999/xhtml" style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 258px; height: 1px; padding-top: 475px; margin-left: 376px;">
                  <div style="box-sizing: border-box; font-size: 0; text-align: center; ">
                     <div style="display: inline-block; font-size: 13px; font-family: Barlow; color: #2B8182; line-height: 1.2; pointer-events: all; font-weight: bold; white-space: normal; word-wrap: normal; "><span>Articles excluded</span></div>
                  </div>
               </div>
            </foreignObject>
            <text x="505" y="479" fill="#2B8182" font-family="Barlow" font-size="13px" text-anchor="middle" font-weight="bold">Articles excluded</text>
         </switch>
      </g>
      <path v-if="prismaInfo['Records excluded based on type of Population/Intervention']" d="M 340 170 L 335 170 Q 330 170 330 180 L 330 220 Q 330 230 325 230 L 322.5 230 Q 320 230 325 230 L 327.5 230 Q 330 230 330 240 L 330 280 Q 330 290 335 290 L 340 290" fill="none" stroke="#000000" stroke-miterlimit="10" pointer-events="all"/>
      <path v-if="prismaInfo['Articles excluded']" d="M 340 420 L 335 420 Q 330 420 330 430 L 330 480 Q 330 490 325 490 L 322.5 490 Q 320 490 325 490 L 327.5 490 Q 330 490 330 500 L 330 550 Q 330 560 335 560 L 340 560" fill="none" stroke="#000000" stroke-miterlimit="10" pointer-events="all"/>
      <rect v-if="prismaInfo['Articles excluded']" x="380" y="550" width="260" height="20" fill="none" stroke="none" pointer-events="all"/>
      <rect v-if="prismaInfo['Articles excluded']" x="375" y="505" width="260" height="20" fill="none" stroke="none" pointer-events="all"/>
      <g v-if="prismaInfo['Articles excluded']" transform="translate(-0.5 -0.5)">
         <switch>
            <foreignObject style="overflow: visible; text-align: left;" pointer-events="none" width="100%" height="100%" requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
               <div xmlns="http://www.w3.org/1999/xhtml" style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 258px; height: 1px; padding-top: 515px; margin-left: 376px;">
                  <div style="box-sizing: border-box; font-size: 0; text-align: center; ">
                     <div style="display: inline-block; font-size: 11px; font-family: Barlow; color: #2B8182; line-height: 1.2; pointer-events: all; white-space: normal; word-wrap: normal; ">
                        <div v-if="prismaInfo['Not a primary study reporting outcome data in humans']"><font size="1"><span style="font-size: 14px" class="formula-content"><span dir="auto" class=" string " style="font-size: 11px">(Not a primary study reporting <br />outcome data in humans = {{prismaInfo['Not a primary study reporting outcome data in humans']}} <span v-if="!prismaInfo['Wrong study design']"> ) </span><br /></span></span></font></div>
                        <div v-if="prismaInfo['Wrong study design']"> <span v-if="!prismaInfo['Not a primary study reporting outcome data in humans']"> (</span> Wrong study design = {{prismaInfo['Wrong study design']}})</div>
                     </div>
                  </div>
               </div>
            </foreignObject>
            <text x="505" y="518" fill="#2B8182" font-family="Barlow" font-size="11px" text-anchor="middle">(Not a primary study reporting...</text>
         </switch>
      </g>
   </g>
   <switch>
      <g requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility"/>
      <a transform="translate(0,-5)" xlink:href="https://www.diagrams.net/doc/faq/svg-export-text-problems" target="_blank">
         <text text-anchor="middle" font-size="10px" x="50%" y="100%">Viewer does not support full SVG 1.1</text>
      </a>
   </switch>
</svg>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import parse from 'csv-parse'
export default {

  name: 'Prisma',
  props: ['gid', 'url', 'sheets'],
  data () {
    return {
      ui: {
        debug: 0,
        viewport: {
          x: 883,
          y: 640,
          w: -60,
          h: 0
        }
      },
      loading: true,
      prismaInfo: {
         'Records identified in L·OVE platform (after duplicates automatically removed)': 0,
         'Records additional searches': 0,
         'Records Screened': 0,
         'Records excluded based on type of Population/Intervention': 0,
         'Full text articles assessed for eligibility': 0,
         'Articles excluded': 0,
         'Wrong study design': 0,
         'Preclinical study': 0,
         'Not a primary study': 0,
         'Ongoing studies': 0,
         'Total RCTs included': 0,
         'Other study designs': 0,
         'Included studies': 0,
         'Not a primary study reporting outcome data in humans': 0,
         'Total references RCTs included': 0
      }
    }
  },
  watch: {},
  mounted: function(){
    if (this.gid && this.url){
       const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem('gapi.access_token')}` }
      }
      let vm = this
      let createList = false
      let type = ""
      let count = 0
      const sheetNumber = this.getSheetNumberByGid(this.sheets, this.gid)
      if(!sheetNumber){
        this.loading = false
        return
      }
      const title = this.sheets[sheetNumber].properties.title
      axios.get(
        'https://sheets.googleapis.com/v4/spreadsheets/'+ this.url + '/values/'+ title+'!A1:AZ9999', config
        )
    .then((res)=>{
      let vm = this
        if (!res.data.hasOwnProperty('values')) {
           return
         }
          for (let i = 0 ; i < res.data.values.length; i++) {
            if (res.data.values[i] 
              && res.data.values[i] != "") {
              let record = res.data.values[i]
              vm.prismaInfo[record[0]]=this.format(record[1])
            } else {
              break
            }
    }})
    .catch((error)=>{
        console.log(error)
      this.loading = false
    })
  }
 },
  methods: {
     getSheetNumberByGid: function(data, gid) {
      for (let i = 0; i < data.length; i++) {
        if (gid == data[i].properties.sheetId) {
          return i
        }
      }
    },
    format: function (number) {
      if (number === undefined) {
        return 0
      }
      if (isNaN(number)){
         return 0
      }
      return parseInt(number)
    },
    zoom: function (value) {
      this.ui.viewport.x += value
      this.ui.viewport.y += value
    },
    area: function (value) {
      this.ui.viewport.w += value
      this.ui.viewport.h += value
    }
  },
  computed: {}
}
</script>




